import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Container from "@mui/material/Container";
import { Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { ListItemIcon } from "@mui/material";
import PersonAdd from "@mui/icons-material/PersonAdd";
import DeleteOutline from "@mui/icons-material/DeleteOutline";

import { useAuth } from "../context/AuthProvider";
import constant from "../utils/constants";

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const { userDetail } = useAuth();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (endpoint) => {
    navigate(endpoint);
  };
  return (
    <AppBar position="static" className="app_header">
      <Container maxWidth="lg">
        <Toolbar sx={{ display: "flex", alignItems: "center" }}>
          {userDetail?.data?.user?.role === constant.userRoles.ADMIN && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ marginRight: "10px" }}
              onClick={handleMenuClick}
            >
              <MenuIcon />
            </IconButton>
          )}

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            <MenuItem onClick={() => handleNavigation("/create-user")}>
              <ListItemIcon>
                <PersonAdd fontSize="small" />
              </ListItemIcon>
              Create User
            </MenuItem>

            <MenuItem onClick={() => handleNavigation("/delete-user")}>
              <ListItemIcon>
                <DeleteOutline fontSize="small" />
              </ListItemIcon>
              Deactivate User
            </MenuItem>

            <MenuItem onClick={() => handleNavigation("/upload-imd")}>
              <ListItemIcon>
                <FileUploadIcon fontSize="small" />
              </ListItemIcon>
              Upload IMD
            </MenuItem>
          </Menu>
          <Typography
            variant="h6"
            component="div"
            className="app_bar_content header "
            sx={{
              flexGrow: 1,
              marginLeft: "12px",
            }}
          >
            <span style={{ position: "relative", top: "-3px" }}>
              <img
                src="/icons/STAAR logo_Final_2025-02.png"
                alt="Zuno Staar Logo"
                style={{
                  height: "66px",
                  marginRight: "-8px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          </Typography>
          <Box>
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="account of current user"
              onClick={() => handleNavigation("/profile")}
            >
              <PermIdentityIcon className="app_bar_content" />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
